import { render, staticRenderFns } from "./HomeAvaliacao.vue?vue&type=template&id=1ebc3505&scoped=true"
import script from "./HomeAvaliacao.vue?vue&type=script&lang=js"
export * from "./HomeAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./HomeAvaliacao.vue?vue&type=style&index=0&id=1ebc3505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc3505",
  null
  
)

export default component.exports